import { createStore } from 'effector'
import { getDailyBonusInfoFx, getFarcanaBonusInfoFx } from './effects'
import {
  DailyBonusItem,
  FarcanaBonusItem,
  GetDailyBonusInfoDTO,
  GetFarcanaBonusInfoDTO,
} from '@/entities/dailyBonus/model/types'

export const $dailyBonusInfo = createStore<GetDailyBonusInfoDTO | null>(null).on(
  getDailyBonusInfoFx.doneData,
  (_, data) => data
)

export const $dailyBonusDay = createStore<number>(1).on($dailyBonusInfo.updates, (state, data) => {
  return data ? data.current_day : state
})

export const $dailyBonusUnlock = createStore<string | null>(null).on($dailyBonusInfo.updates, (state, data) => {
  return data ? data.next_bonus_unlock : state
})

export const $dailyBonusRewards = createStore<DailyBonusItem[][] | null>(null).on(
  $dailyBonusInfo.updates,
  (state, data) => {
    return data ? data.list_daily_bonus : state
  }
)

export const $farcanaBonusInfo = createStore<GetFarcanaBonusInfoDTO | null>(null).on(
  getFarcanaBonusInfoFx.doneData,
  (_, data) => data
)

export const $farcanaBonusStreak = createStore<number>(0).on($farcanaBonusInfo.updates, (state, data) => {
  return data ? data.current_streak : state
})

export const $farcanaBonusRewards = createStore<FarcanaBonusItem[] | null>(null).on(
  $farcanaBonusInfo.updates,
  (state, data) => {
    return data ? data.list_farcana_bonus : state
  }
)
